import { ReactNode } from "react";

import {
  makeStyles,
  createStyles,
  FormHelperText,
  Theme,
  FormControl,
  FormLabel,
  FormControlProps,
} from "@material-ui/core";

export type InputWrapperProps = {
  id: string;
  label?: string;
  error?: any;
  children?: ReactNode;
  input?: boolean;
} & FormControlProps;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: "flex",
      flexDirection: "column",

      "& label": {
        fontSize: 16,
        fontWeight: 600,
        color: theme.palette.dark.main,

        marginBottom: theme.spacing(2),
      },
    },
    labelFocus: {
      color: `${theme.palette.dark.main} !important`,
    },
    status: {
      fontWeight: "normal",
      color: theme.palette.error.main,

      marginTop: theme.spacing(0.75),
    },
  }),
);

export const InputWrapper = ({ label, id, error, children, input = false }: InputWrapperProps) => {
  const classes = useStyles();
  return (
    <FormControl component="fieldset" className={classes.wrapper}>
      {label && (
        <FormLabel
          htmlFor={id}
          classes={{ focused: classes.labelFocus }}
          style={{
            marginBottom: input ? 8 : 16,
          }}
        >
          {label}
        </FormLabel>
      )}

      {children}

      {Boolean(error) && <FormHelperText className={classes.status}>{error}</FormHelperText>}
    </FormControl>
  );
};
